import styled from "styled-components";
import {Collapse} from "antd";

export const StyledCollapse  = styled(Collapse)`
  border-radius: 0;
  border: none;
  background-color: transparent;
  
  .ant-collapse-item{
    border: 1px solid #E8E8E8;
    border-radius: 0 !important;
    
    &:not(:last-child){
      margin-bottom: 16px;
    }
    
    .ant-collapse-header{
      background-color: #fff;
      border-radius: 0 !important;
    }
    
    .ant-collapse-content{
      border-top: none !important;
      
      .ant-collapse-content-box{
        padding: 0!important;
        
        .item{
          padding: 8px;
          
          &:not(:last-child){
            border-bottom: 1px solid #E8E8E8;
          }
        }
      }
    }
    
    
    &.ant-collapse-item-active{
      
      .ant-collapse-header{
        background-color: #E6F3E5;
      }
    }
  }
`